import script from "./EzTableErrorState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EzTableErrorState.vue?vue&type=script&setup=true&lang=ts"

import "./EzTableErrorState.vue?vue&type=style&index=0&id=331183f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331183f4"]])

export default __exports__